import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { SidebarTrigger } from '../ui/sidebar.js';
import { useApp } from '../../contexts/AppContext.js';
import { useUser, OrganizationSwitcher, UserButton } from '@clerk/clerk-react';
import { dark } from '@clerk/themes';
import { useState, useEffect } from 'react';

function Navigation({ headerActions } = {}) {
    const { config } = useApp();
    const [actualTheme, setActualTheme] = useState('light');
    // Update actual theme based on current theme setting
    useEffect(() => {
        const updateActualTheme = () => {
            const isDark = document.documentElement.classList.contains('dark') ||
                window.matchMedia('(prefers-color-scheme: dark)').matches;
            setActualTheme(isDark ? 'dark' : 'light');
        };
        updateActualTheme();
        // Listen for theme changes
        const observer = new MutationObserver(updateActualTheme);
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class'],
        });
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        mediaQuery.addEventListener('change', updateActualTheme);
        return () => {
            observer.disconnect();
            mediaQuery.removeEventListener('change', updateActualTheme);
        };
    }, []);
    const { user } = useUser();
    return (
    // Card (white) rather than page background so the bar stays white on
    // apps with a tinted paper background. Solid — translucency lets the
    // tinted background bleed through.
    jsx("header", { className: "border-b bg-card", children: jsxs("div", { className: "flex h-14 items-center justify-between px-6", children: [jsxs("div", { className: "flex items-center space-x-3", children: [jsx(SidebarTrigger, {}), jsx(OrganizationSwitcher
                        // Switching organization changes what the whole app is
                        // about, and the page you were on almost certainly belonged
                        // to the organization you just left — a hotel detail, an
                        // offer, a list scoped to the old org. Staying put showed
                        // either someone else's record or an empty screen, so send
                        // people home and let them navigate into the new context.
                        , { 
                            // Switching organization changes what the whole app is
                            // about, and the page you were on almost certainly belonged
                            // to the organization you just left — a hotel detail, an
                            // offer, a list scoped to the old org. Staying put showed
                            // either someone else's record or an empty screen, so send
                            // people home and let them navigate into the new context.
                            afterSelectOrganizationUrl: "/", afterSelectPersonalUrl: "/", appearance: {
                                baseTheme: actualTheme === 'dark' ? dark : undefined,
                                elements: {
                                    organizationSwitcherPopoverActionButton__createOrganization: {
                                        display: config?.organizations?.allowUserCreateOrganization ? undefined : 'none',
                                    },
                                    organizationSwitcherTrigger: 'border-none shadow-none',
                                    organizationSwitcherPopoverCard: 'w-[280px]',
                                    createOrganization: config?.organizations?.allowUserCreateOrganization
                                        ? undefined
                                        : 'hidden',
                                },
                            } })] }), jsxs("div", { className: "flex items-center self-stretch", children: [headerActions && (jsxs(Fragment, { children: [jsx("div", { className: "border-l border-border self-stretch" }), jsx("div", { className: "flex items-center self-stretch px-4", children: headerActions })] })), jsx("div", { className: "border-l border-border self-stretch" }), jsxs("div", { className: "flex items-center gap-3 pl-4", children: [jsx(UserButton, { appearance: {
                                        baseTheme: actualTheme === 'dark' ? dark : undefined,
                                    } }), jsxs("div", { className: "hidden sm:flex flex-col", children: [jsx("span", { className: "text-sm font-medium leading-tight text-foreground", children: user?.fullName }), jsx("span", { className: "text-xs leading-tight text-muted-foreground", children: user?.primaryEmailAddress?.emailAddress })] })] })] })] }) }));
}

export { Navigation };
//# sourceMappingURL=Navigation.js.map
